<template>
  <div id="list-auth-mac">
    <v-card>
      <v-card-text>
        <v-card flat>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  label="MAC"
                  single-line
                  append-icon="mdi-magnify"
                  v-model="datatableProxyFilters.mac"
                  @keydown="() => clearTypingTimer(typingTimerIdMac)"
                  @keyup="triggerTypingTimerMac"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat>
          <v-card-text>
            <authentification-m-a-c-datatable
              :filter-params="filterParams"
            ></authentification-m-a-c-datatable>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, reactive, toRef } from "@vue/composition-api";
import { useTitle } from "@/composables/title";
import { useClientPortal } from "@/composables/client-portal";
import AuthentificationMACDatatable from "../components/AuthentificationMAC/AuthentificationMACDatatable";

export default {
  components: { AuthentificationMACDatatable },
  setup() {
    const { setTitle, setIcon } = useTitle();
    const { data } = useClientPortal();

    /* Cycle de vie */
    onMounted(() => {
      setTitle("Cache re-authentification MAC");
      setIcon("mac");
    });

    /* Variables */
    const filterParams = reactive({
      mac: "",
      client: "",
    });
    const datatableProxyFilters = reactive({
      mac: "",
      client: "",
    });
    let typingTimerIdMac = 0;
    const debounceInterval = 500;

    /* Méthodes */
    const updateSearchTerm = () => {
      filterParams.mac = datatableProxyFilters.mac;
      filterParams.client = datatableProxyFilters.client;
    };

    const triggerTypingTimerMac = function () {
      clearTimeout(typingTimerIdMac);
      typingTimerIdMac = setTimeout(function () {
        updateSearchTerm();
      }, debounceInterval);
    };
    const clearTypingTimer = function (timerId) {
      clearTimeout(timerId);
    };

    return {
      clientPortals: toRef(data, "clientPortals"),
      isClientPortalsLoading: toRef(data, "isLoading"),
      datatableProxyFilters,
      triggerTypingTimerMac,
      clearTypingTimer,
      typingTimerIdMac,
      filterParams,
    };
  },
};
</script>
